<template>
    <v-container fluid class="pa-0 ">
        <v-container class="pa-0">
            <!-- Overview header -->
            <v-card flat>
                <v-card-title>
                    <v-row class="my-0 px-3 align-end">
                        <v-col cols="auto">
                            <h2 class="display-3 font-weight-medium">
                                Instellingen
                            </h2>
                            <!-- <v-progress-linear
                                :active="isLoading"
                                color="primary"
                                buffer-value="0"
                                stream
                                class="mx-0 mt-2 px-0"
                            ></v-progress-linear> -->
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto" class="mr-auto">
                            <v-tabs v-model="tab" class="justify-center">
                                <v-tab>Mijn Instellingen</v-tab>
                                <v-tab v-show="!me.isStaff && me.isTenantAdmin"
                                    >Gebruikers</v-tab
                                >
                                <v-tab v-show="!me.isStaff && me.isTenantAdmin"
                                    >Groepen</v-tab
                                >
                                <v-tab v-show="me.isStaff && me.isSuperuser"
                                    >Medewerkers</v-tab
                                >
                            </v-tabs>
                        </v-col>
                    </v-row>
                </v-card-title>
            </v-card>
        </v-container>

        <!-- Overview  body -->
        <v-card flat color="grey lighten-4 pt-15" min-height="73vh" fill-width>
            <router-view @loading="onLoading"></router-view>
        </v-card>
    </v-container>
</template>

<script>
import helper from "@/utils/helper.js";

export default {
    title: "Instellingen",
    components: {},

    apollo: {},

    data() {
        return {
            tab: 0,
            isLoading: false
        };
    },

    computed: {
        me() {
            return this.$store.state.user.me || {};
        }
    },
    watch: {
        tab(val) {
            switch (val) {
                case 0:
                    this.pushTo("mijngegevens");
                    break;
                case 1:
                    this.pushTo("gebruikers");
                    break;
                case 2:
                    this.pushTo("groepen");
                    break;
                case 3:
                    this.pushTo("staffs");
                    break;
                default:
                    this.pushTo("mijngegevens");
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
        this.pushTo = helper.pushTo;
    },
    mounted() {
        this.pushTo("mijngegevens");
    },
    methods: {
        onLoading(val) {
            this.isLoading = val;
        }
    }
};
</script>